<div class="container">
  <main id="content" class="unauthorized-container" role="main">
    <div class="row">
      <div class="col-md-6 col-10 offset-md-3 offset-1">
        <div class="unauthorized-container">
          <h1 class="unauthorized-code">Not Authorized</h1>
        </div>
      </div>
    </div>
      <div class="row">
          <div class="col-12">
              <p class="unauthorized-info">
                  Oops, it seems that you do not have permission to access this page. Please contact a Log Assistance administrator if you believe this is an error.
              </p>
          </div>
      </div>
  </main>
</div>
